import { Shift } from "Models/Tasks/Shift";

export interface IShiftState {
    companyShifts: Shift[];
    areaShifts: Shift[];
    hasAreaShifts: boolean | undefined;
}

export class ShiftState implements IShiftState {
    public companyShifts = [];
    public areaShifts = [];
    public hasAreaShifts: boolean | undefined = undefined;
}


// WEBPACK FOOTER //
// ./src/Store/Shifts/ShiftState.ts